import { WidgetType } from 'widgets/WidgetType.ts';
import { buildHistoricalPercentageChangeStoreSlice } from 'widgets/historicalPercentageChange/store/slice.ts';
import { HistoricalPercentageChangeConfig } from 'widgets/historicalPercentageChange/store/HistoricalPercentageChangeConfig.ts';
import { useConfigSlice } from 'widgets/store/configuration/configSlice.ts';

export const initialHistoricalPercentageChangeCapsuleConfigState: HistoricalPercentageChangeConfig =
    {
        view: 'chart',
        periodQty: 10,
        sort: [],
        visibleColumns: [],
        columnWidths: {},
        hideVolumeLegend: false,
        hideVolume: false,
        hidePriceLegend: false,
        hidePrice: false,
        hideAverageVolume: false,
    };

const { configSlice, reducer } = buildHistoricalPercentageChangeStoreSlice(
    WidgetType.HistoricalPercentageChangeCapsule,
    initialHistoricalPercentageChangeCapsuleConfigState
);

const useHistoricalPercentageChangeCapsuleConfigSlice = () => {
    const { config, dispatchConfigChanged } = useConfigSlice(configSlice);
    return {
        config: config ?? initialHistoricalPercentageChangeCapsuleConfigState,
        dispatchConfigChanged,
    };
};

export { reducer, useHistoricalPercentageChangeCapsuleConfigSlice };
